import numeral from 'numeral';
import IsQuickMoveIn from './customFilters/IsQuickMoveIn';
import CustomHomePrice from './customFilters/Homes/CustomPrice';
import CustomHomeSqft from './customFilters/Homes/CustomSQFT';
import CustomHomeStyles from './customFilters/Homes/CustomStyles';
import CustomPlanSqft from './customFilters/Plans/CustomSQFT';
import CustomPlanStyles from './customFilters/Plans/CustomStyles';
import PlanStyle from './customFilters/PlanStyle';

const config = {
  builder_id: '5b772cbe4db0483f337be354',
  auth_domain: 'arjenhomes.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/social/facebook.svg',
    instagram: '/images/social/instagram.svg',
    youtube: '/images/social/youtube.svg',
    pinterest: '/images/social/pinterest.svg',
    twitter: '/images/social/twitter.svg',
    houzz: '/images/social/houzz.svg',
    linkedin: '/images/social/linkedin.svg',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2tiN3pramg1MGFxejJ3bWU1MG00aXBiOSJ9.yPxZh5L4l_QWp1GszmvQPw',
  },
  filters: {
    all: {
      Area: {
        routeParam: 'communityMarketArea',
      },
      Price: {
        labelRender: ({ value }) => `${numeral(value.start).format('$0,0')} - ${numeral(value.end).format('$0,0')}`,
      },
      Sqft: {
        labelRender: ({ value }) => `${numeral(value.start).format('0,0')} - ${numeral(value.end).format('0,0')}`,
      },
    },
    homes: {
      IsQuick: IsQuickMoveIn,
      CustomPrice: CustomHomePrice,
      CustomSqft: CustomHomeSqft,
      CustomStyles: CustomHomeStyles,
    },
    plans: {
      FloorPlanStyle: PlanStyle,
      CustomSqft: CustomPlanSqft,
      CustomPlanStyles,
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js